import { postRequest, ApiResponse } from "@/data/apiClient";

export interface userDisconnectRequest {
  userId: number;
}
export interface userDisconnectResponse {
  [key: string]: never;
}

export const userDisconnect = async (
  userId: number
): Promise<ApiResponse<userDisconnectResponse>> =>
  postRequest("user/logout", { userId });
